import Head from "next/head";
import { fetchGetBanners } from "../../../services/api";
import SingleBanner from "../../components/default/single-banner";
import FinancingForm from "../../components/financing/financing-form";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";

export default function FinancingPage({ companyGeneralData, banner }) {
    companyGeneralData = JSON.parse(companyGeneralData);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content={`Financie seu carro usado ou seminovo na MSX Motors em Jacareí. Atendimento especializado, análise facilitada, troca e opções com ou sem entrada.`} />
                <meta name="keywords" content={`financiamento de veículos Jacareí, financiar carro usado, financiamento sem entrada, financiamento de seminovos, simulação de financiamento, MSX Motors`} />
                <meta name="author" content="https://bndv.com.br" />
                <title>{`Financiamento de Veículos em Jacareí | MSX Motors`}</title>
            </Head>

            <div className="main-wrapper">
                <Header company={companyGeneralData.company} />
                {banner ? <SingleBanner imageUrl={banner.imageUrl} /> : null}
                <FinancingForm />
                <Footer company={companyGeneralData.company} />
            </div>
        </>
    )
}

export async function getServerSideProps() {
    const banners = await fetchGetBanners({ idMenuOption: 6 });

    return {
        props: {
            banner: (banners && banners.length > 0) ? banners[0].banner : null
        }
    }
}